/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionGeneratedDocumentExternalEhrDocument
 */
export interface PalAuthSubmissionGeneratedDocumentExternalEhrDocument {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocumentExternalEhrDocument
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocumentExternalEhrDocument
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocumentExternalEhrDocument
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocumentExternalEhrDocument
     */
    external_ehr_document_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocumentExternalEhrDocument
     */
    relation_type?: PalAuthSubmissionGeneratedDocumentExternalEhrDocumentRelationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocumentExternalEhrDocument
     */
    relation_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocumentExternalEhrDocument
     */
    created_at?: string;
}


/**
 * @export
 */
export const PalAuthSubmissionGeneratedDocumentExternalEhrDocumentRelationTypeEnum = {
    Document: 'screener_document',
    AdditionalDocument: 'screener_additional_document',
    GeneratedDocument: 'screener_generated_document'
} as const;
export type PalAuthSubmissionGeneratedDocumentExternalEhrDocumentRelationTypeEnum = typeof PalAuthSubmissionGeneratedDocumentExternalEhrDocumentRelationTypeEnum[keyof typeof PalAuthSubmissionGeneratedDocumentExternalEhrDocumentRelationTypeEnum];


/**
 * Check if a given object implements the PalAuthSubmissionGeneratedDocumentExternalEhrDocument interface.
 */
export function instanceOfPalAuthSubmissionGeneratedDocumentExternalEhrDocument(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionGeneratedDocumentExternalEhrDocumentFromJSON(json: any): PalAuthSubmissionGeneratedDocumentExternalEhrDocument {
    return PalAuthSubmissionGeneratedDocumentExternalEhrDocumentFromJSONTyped(json, false);
}

export function PalAuthSubmissionGeneratedDocumentExternalEhrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionGeneratedDocumentExternalEhrDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'external_ehr_document_id': !exists(json, 'external_ehr_document_id') ? undefined : json['external_ehr_document_id'],
        'relation_type': !exists(json, 'relation_type') ? undefined : json['relation_type'],
        'relation_id': !exists(json, 'relation_id') ? undefined : json['relation_id'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
    };
}

export function PalAuthSubmissionGeneratedDocumentExternalEhrDocumentToJSON(value?: PalAuthSubmissionGeneratedDocumentExternalEhrDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'type': value.type,
        'external_ehr_document_id': value.external_ehr_document_id,
        'relation_type': value.relation_type,
        'relation_id': value.relation_id,
        'created_at': value.created_at,
    };
}

